import { EVEN_MONTHLY_FAMILY_KEYS, ITEM_BASED_FAMILY_KEYS } from '../services/schedulePreview';

export function isIllustrativeScheduleMethod(methodKey: string | null | undefined): boolean {
    if (!methodKey) return false;
    return EVEN_MONTHLY_FAMILY_KEYS.has(methodKey) || ITEM_BASED_FAMILY_KEYS.has(methodKey);
}
